import type {OfflineCaptureSnapshot, OfflineCompletionScope} from '@/api/offlineCapture'
const UUID=/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/
export function validateCompletion(snapshot:OfflineCaptureSnapshot) {
  const value=snapshot.resources.completion
  if (value === undefined) return
  const fail=()=>{throw new Error('Snapshot completion is invalid')}
  const count=(n:unknown)=>typeof n==='number' && Number.isSafeInteger(n) && n>=0
  const number=(n:unknown)=>typeof n==='number' && Number.isFinite(n) && n>=0
  if (!value || value.version!==1 || !count(value.criterionCount) || !number(value.minSelectorsForConfidence) || !number(value.minDataForConfidence) || typeof value.sessionHasRows!=='boolean' || !Array.isArray(value.participants)) fail()
  let entries=value.participants.length
  const participantIds=new Set(snapshot.resources.participants.map(p=>p.id)), seen=new Set<string>(), activities=new Set(snapshot.resources.activities.map(a=>a.id))
  const activityMap=(map:Record<string,number>)=>{
    if (!map || typeof map!=='object' || Array.isArray(map)) fail()
    for(const [id,n] of Object.entries(map)) {if(!activities.has(id)||!count(n))fail();entries++}
  }
  const scope=(s:OfflineCompletionScope)=>{
    if(!s || !count(s.assessorCount) || typeof s.actorHasEntry!=='boolean' || (s.actorHasEntry && !s.assessorCount) || typeof s.hasScoreElements!=='boolean' || !Array.isArray(s.criterionIds) || new Set(s.criterionIds).size!==s.criterionIds.length || s.criterionIds.some(id=>!UUID.test(id)))fail()
    entries+=s.criterionIds.length
  }
  for(const row of value.participants) {
    if(!participantIds.has(row.participantId)||seen.has(row.participantId))fail()
    seen.add(row.participantId);scope(row.overall);scope(row.session)
    if(row.legacySession)scope(row.legacySession)
    activityMap(row.activityObservations)
  }
  if(seen.size!==participantIds.size)fail()
  activityMap(value.activityMaxObservations)
  if(snapshot.counts.completionEntries!==entries)fail()
}
